(function () {
    'use strict';
    //Module to store common controllers in the view
    angular.module('ib-anonymous-search-module', []);
})();